import type { QuizAnswers } from '@/features/quiz/types';

/** Matches iOS `QuestionnaireSubmission.versionCurrent`. */
export const ONBOARDING_QUESTIONNAIRE_VERSION = 2;

/** Web quiz step ids → iOS / API questionnaire keys. */
const QUESTION_ID_MAP: Record<string, string> = {
  gender: 'gender',
  facebook_instagram: 'social',
  visa_mastercard: 'payment',
  yahoo_mail: 'yahoo',
  tmobile: 'tmobile',
  credit_bureaus: 'credit',
  '23andme': 'dna',
  amazon: 'amazon',
  marriott: 'marriott',
  google_gmail: 'google',
};

const ANSWER_VALUE_MAP: Record<string, string> = {
  skip: 'prefer_not_to_say',
};

export interface OnboardingQuestionnaire {
  answers: Record<string, string>;
  version: number;
}

export function buildOnboardingQuestionnaire(answers: QuizAnswers): OnboardingQuestionnaire {
  const mapped: Record<string, string> = {};
  for (const [stepId, value] of Object.entries(answers)) {
    const apiId = QUESTION_ID_MAP[stepId];
    if (!apiId || typeof value !== 'string' || !value) continue;
    mapped[apiId] = ANSWER_VALUE_MAP[value] ?? value;
  }
  return { answers: mapped, version: ONBOARDING_QUESTIONNAIRE_VERSION };
}
